import React, { Dispatch } from 'react';

export const emojiList = [
  { id: 0, emoji: '😣' },
  { id: 1, emoji: '😞' },
  { id: 2, emoji: '😐' },
  { id: 3, emoji: '🤔' },
  { id: 4, emoji: '🙂' },
  { id: 5, emoji: '🤩' },
];

interface EmojiSelectorProps {
  feelingEmojiSelectedId: number | null
  setFeelingEmojiSelectedId?: Dispatch<React.SetStateAction<number | null>>
  editing?: boolean
}

export default function EmojiSelector({
  setFeelingEmojiSelectedId,
  feelingEmojiSelectedId,
  editing = true
}: EmojiSelectorProps) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      {emojiList.map(({ id, emoji }) => (
        <span
          key={id}
          onClick={() => {
            if (editing && setFeelingEmojiSelectedId) {
              setFeelingEmojiSelectedId(id)
            }
          }}
          style={{
            fontSize: '2rem',
            cursor: editing ? 'pointer' : 'default',
            filter: feelingEmojiSelectedId === id ? 'none' : 'grayscale(100%)',
            transition: 'filter 0.2s'
          }}
        >
          {emoji}
        </span>
      ))}
    </div>
  );
}
